import { call, put, takeEvery, all } from 'redux-saga/effects';
import UserApi from '../../api/UserApi';
import * as Actions from '../actions/usersActions';
import * as Types from '../actions/usersActionTypes';

function* getUser() {
  try {
    const response = yield call(UserApi.getUser);
    console.info(response);
    yield put(Actions.getUserSuccess(response));
  } catch (error) {
    console.info(error);
    yield put(Actions.getUserFailure(error));
  }
}

function* invite(action) {
  try {
    const response = yield call(UserApi.invite, action.data);
    console.info(response);
    yield put(Actions.inviteSuccess(response));
    yield call(action.onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.inviteFailure(error));
    yield call(action.onFail, error);
  }
}

function* getUsers() {
  try {
    const response = yield call(UserApi.getUsers);
    console.info(response);
    yield put(Actions.getUsersSuccess(response));
  } catch (error) {
    console.info(error);
    yield put(Actions.getUsersFailure(error));
  }
}

function* updateUser(action) {
  try {
    const response = yield call(UserApi.updateUser, action.data);
    console.info(response);
    yield put(Actions.updateUserSuccess(response));
    yield call(action.onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.updateUserFailure(error));
    yield call(action.onFail, error);
  }
}

function* changePassword(action) {
  try {
    const response = yield call(UserApi.changePassword, action.data);
    console.info(response);
    yield put(Actions.changePasswordSuccess(response));
    yield call(action.onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.changePasswordFailure(error));
    yield call(action.onFail, error);
  }
}

function* resetPassword(action) {
  try {
    const response = yield call(UserApi.resetPassword, { email: action.email });
    console.info(response);
    yield put(Actions.resetPasswordSuccess(response));
    yield call(action.onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.resetPasswordFailure(error));
    yield call(action.onFail, error);
  }
}

function* setPassword(action) {
  try {
    const response = yield call(UserApi.setPassword, action.data);
    console.info(response);
    sessionStorage.setItem('jwt', response.token);
    if (action.staySignedIn) localStorage.setItem('jwt', response.token);
    yield put(Actions.setPasswordSuccess(response));
    yield put(Actions.getUser());
    yield put(Actions.getUsers());
  } catch (error) {
    console.info(error);
    yield put(Actions.setPasswordFailure(error));
    yield call(action.onFail, error);
  }
}

function* welcome(action) {
  try {
    const response = yield call(UserApi.welcome, action.data);
    console.info(response);
    sessionStorage.setItem('jwt', response.token);
    if (action.staySignedIn) localStorage.setItem('jwt', response.token);
    yield put(Actions.welcomeSuccess(response));
    yield put(Actions.getUser());
    yield put(Actions.getUsers());
  } catch (error) {
    console.info(error);
    yield put(Actions.welcomeFailure(error));
    yield call(action.onFail, error);
  }
}

function* join(action) {
  try {
    const response = yield call(UserApi.join, action.data);
    console.info(response);
    sessionStorage.setItem('jwt', response.token);
    yield put(Actions.joinSuccess(response));
    yield put(Actions.getUser());
    yield put(Actions.getUsers());
  } catch (error) {
    console.info(error);
    yield put(Actions.joinFailure(error));
    yield call(action.onFail, error);
  }
}

export default function* userFlow() {
  yield all([
    takeEvery(Types.GET_USER, getUser),
    takeEvery(Types.INVITE, invite),
    takeEvery(Types.GET_USERS, getUsers),
    takeEvery(Types.UPDATE_USER, updateUser),
    takeEvery(Types.CHANGE_PASSWORD, changePassword),
    takeEvery(Types.RESET_PASSWORD, resetPassword),
    takeEvery(Types.SET_PASSWORD, setPassword),
    takeEvery(Types.WELCOME, welcome),
    takeEvery(Types.JOIN, join),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/userFlow.js